export const COMPONENT_NAME = 'TopShelfRail';
export const HEIGHT_BY_DEFAULT_PORTRAIT = 484;
export const HEIGHT_BY_DEFAULT_LANDSCAPE = 271;
export const MIN_NUMBER_OF_ITEMS = 4;
export const SKELETON_TEXT_LINE_NUMBER = 3;
export const SKELETON_WIDTH = 320;
export const SKELETON_HEIGHT = 480;
